import React from "react";
import { StoryboardItem } from "src/types/experiences/storyboards";
import { StoryboardType } from "src/types/experiences/storyboardSettings/storyboard";

export type EditMode = "clone" | "delete" | "rename" | null;

export interface UploadingStoryboard {
  id: string; // local uuid
  name: string;
  contentType: StoryboardType;
  thumbnailUrl: string | null;
  progress: number; // 0–100
  status: "uploading" | "processing";
}

export type RenameEditType = "storyboard" | "folder";

export interface RenameEdit {
  type: RenameEditType;
  name: string;
}

export interface StoryboardsContextProps {
  editMode: EditMode;
  // Multi-select capable: delete toggles many; clone keeps a single entry.
  selectedStoryboards: StoryboardItem[];
  onStoryboardSelect: (storyboard: StoryboardItem | null) => void;
  onEditModeChange: (mode: EditMode) => void;
  // Staged rename edits (folders + storyboards), keyed by id. Committed on Save.
  renameEdits: Record<string, RenameEdit>;
  onRenameChange: (id: string, type: RenameEditType, name: string) => void;
  uploads: UploadingStoryboard[];
  addUpload: (upload: UploadingStoryboard) => void;
  updateUpload: (id: string, patch: Partial<UploadingStoryboard>) => void;
  removeUpload: (id: string) => void;
}

export const StoryboardsContext = React.createContext<StoryboardsContextProps>({
  editMode: null,
  selectedStoryboards: [],
  onStoryboardSelect: () => {},
  onEditModeChange: () => {},
  renameEdits: {},
  onRenameChange: () => {},
  uploads: [],
  addUpload: () => {},
  updateUpload: () => {},
  removeUpload: () => {},
});
